const isPlainObject = (value) => (
  value !== null && typeof value === "object" && !Array.isArray(value)
);

/**
 * Builds the effective catalogue without mutating either source.
 * Presence is intentional: an empty string, false, 0 or {} stored in
 * MongoDB remains authoritative. Only an absent property falls back to JSON.
 *
 * Exception: an empty MongoDB array. Every array path of the FrTxtLanguage
 * schema (elakayTicket, errorMessage, advertisingEmail, ...) defaults to []
 * in Mongoose, so a stored [] cannot be told apart from "never edited" --
 * letting it win hid the whole bundled catalogue (e.g. the Orders
 * cancel/return reason list was always empty). A non-empty MongoDB array
 * still wins as a whole.
 */
export const mergeLanguageSources = (mongoValue, jsonValue) => {
  if (mongoValue === undefined) return jsonValue;
  if (Array.isArray(mongoValue) && mongoValue.length === 0
      && Array.isArray(jsonValue) && jsonValue.length > 0) return jsonValue;

  if (isPlainObject(mongoValue) && isPlainObject(jsonValue)) {
    const merged = { ...jsonValue };
    Object.keys(mongoValue).forEach((key) => {
      merged[key] = Object.prototype.hasOwnProperty.call(jsonValue, key)
        ? mergeLanguageSources(mongoValue[key], jsonValue[key])
        : mongoValue[key];
    });
    return merged;
  }

  // Arrays are business entities in this model. Combining them by index would
  // risk attaching JSON text to the wrong MongoDB subdocument, so a present,
  // non-empty MongoDB array wins as a whole.
  return mongoValue;
};

export const effectiveLanguageSection = (mongoCatalogue, jsonCatalogue, key) => {
  if (key === undefined || key === null || key === "") {
    return mergeLanguageSources(mongoCatalogue, jsonCatalogue);
  }
  const mongoHasKey = mongoCatalogue != null
    && Object.prototype.hasOwnProperty.call(mongoCatalogue, key);
  return mergeLanguageSources(
    mongoHasKey ? mongoCatalogue[key] : undefined,
    jsonCatalogue?.[key]
  );
};

